export const noteType = [
  { value: 'Médica', label: 'Médica' },
  { value: 'Cosmetológica', label: 'Cosmetológica' },
  { value: 'Administrativa', label: 'Administrativa' },
];
